function handRub500mlStrategy(amount) {
    if (amount >= 900) {
        return 5.7;
    } else if (amount >= 600) {
        return 6;
    } else if (amount >= 300) {
        return 6.1;
    } else {
        return 7;
    }
}

function handRub1000mlStrategy(amount) {
    if (amount >= 480) {
        return 9.2;
    } else if (amount >= 300) {
        return 9.6;
    } else if (amount >= 120) {
        return 10.1;
    } else {
        return 10.9;
    }
}

function pumpStrategy(amount) {
    if (amount >= 480) {
        return 0.97;
    } else if (amount >= 300) {
        return 1;
    } else if (amount >= 120) {
        return 1.05;
    } else {
        return 1.15;
    }
}

function displayStrategy(amount) {
    if (amount >= 100) {
        return 90;
    } else if (amount >= 50) {
        return 92.5;
    } else {
        return 95;
    }
}

function maskStrategy(amount) {
    if (amount >= 6000) {
        return 0.7;
    } else {
        return 0.75;
    }
}

export {
    handRub500mlStrategy,
    handRub1000mlStrategy,
    pumpStrategy,
    displayStrategy,
    maskStrategy
}